import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RegexExpressions } from 'shared/constants/regex/regex-expressions';
import { DeviceType } from 'shared/models/device-type';

import CreateLinkableTransmitterCommand from 'features/residents/resident-settings/components/resident-setting-details/components/devices-accordion/components/details-devices/components/linkable-transmitter-steps/domain/create-linkable-transmitter-command';

type RegisterOptions = {
  externalIdG2: {
    required: string;
    pattern: {
      value: RegExp;
      message: string;
    };
  };
  externalIdDesoTransmitter: {
    required: string;
    pattern: {
      value: RegExp;
      message: string;
    };
  };
};

type UseEnterDeviceIdStepReturn = {
  deviceType: DeviceType;
  registerOptions: RegisterOptions;
};

const useEnterDeviceIdStep = (form: UseFormReturn<CreateLinkableTransmitterCommand>): UseEnterDeviceIdStepReturn => {
  const { t } = useTranslation('residentsSettings', { keyPrefix: 'linkableDevicesModal.linkableTransmitterSteps' });

  const deviceType = form.watch('type');

  const registerOptions = {
    externalIdG2: {
      required: t('deviceIdFieldRequired'),
      pattern: {
        value: RegexExpressions.EXTERNAL_ID_G2,
        message: t('externalIdG2FormatHelperText'),
      },
    },
    externalIdDesoTransmitter: {
      required: t('deviceIdFieldRequired'),
      pattern: {
        value: RegexExpressions.EXTERNAL_ID_DESO_TRANSMITTER,
        message: t('externalIdDesoFormatHelperText'),
      },
    },
  };

  return {
    deviceType,
    registerOptions,
  };
};

export default useEnterDeviceIdStep;
